export default __webpack_public_path__ + "static/media/office-buildings.640f1449.svg";